<template>
  <bar-chart
    :height="height"
    :chart-data="chartConfig"
  />
</template>

<script>
import BarChart from "@/components/Charts/BarChart";

export default {
  name: 'AvaliationDateChart',
  components: { BarChart },
  props: {
    chartData: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      default: 250,
    },
  },
  computed: {
    chartConfig() {
      if (!this.chartData || !this.chartData.data) return {};

      const labels = Object.keys(this.chartData.data) || [];
      const values = Object.values(this.chartData.data) || [];

      return {
        labels: labels.map(this.$options.filters.formatDate),
        datasets: [
          {
            label: 'Respostas',
            backgroundColor: '#2dce8a',
            data: values,
          },
        ],
      };
    },
  }
}
</script>
